<template>
    <!-- Portfolio section -->
	<section class="portfolio-section">
		<div class="container">
			<div class="row">
				<div class="col-lg-4 col-md-7">
					<router-link to="/makeup-and-hair.html" class="portfolio-item">
						<img src="img/portfolio/1.jpg" alt="איפור ושיער מקצועי לכלות ואירועים באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ושיער</h4>
					</router-link>
				</div>
				<div class="col-lg-3 col-md-5">
					<router-link to="/evening.html" class="portfolio-item">
						<img src="img/portfolio/2.jpg" alt="איפור ערב זוהר ומקצועי באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ערב</h4>
					</router-link>
				</div>
				<div class="col-lg-5 col-md-12">
					<router-link to="/makeup-and-hair.html" class="portfolio-item">
						<img src="img/portfolio/3.jpg" alt="איפור אופנה וצילומים באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור אופנה</h4>
					</router-link>
				</div>
				<div class="col-lg-6 col-md-12">
					<router-link to="/makeup-and-hair.html" class="portfolio-item">
						<img src="img/portfolio/4.jpg" alt="איפור ועיצוב תסרוקת לאירוע באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ושיער</h4>
					</router-link>
				</div>
				<div class="col-lg-3 col-sm-6">
					<router-link to="/evening.html" class="portfolio-item">
						<img src="img/portfolio/5.jpg" alt="איפור ערב ונשף סיום באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור לנשף</h4>
					</router-link>
					<router-link to="/evening.html" class="portfolio-item">
						<img src="img/portfolio/7.jpg" alt="איפור ערב עדין ומודרני באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ערב</h4>
					</router-link>
				</div>
				<div class="col-lg-3 col-sm-6">
					<router-link to="/evening.html" class="portfolio-item">
						<img src="img/portfolio/6.jpg" alt="איפור ערב מקצועי ומחמיא באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ערב</h4>
					</router-link>
					<router-link to="/evening.html" class="portfolio-item">
						<img src="img/portfolio/8.jpg" alt="איפור ערב לאירועים מיוחדים באשדוד - יעל תמם" loading="lazy"/>
						<h4>איפור ערב</h4>
					</router-link>
				</div>
			</div>
		</div>
	</section>
</template>

<!-- Portfolio section end-->
<script>
	export default {
		name: 'PortfolioSection'
	};
</script>

<style scoped>
	.portfolio-item img {
		width: 100%;
		height: auto;
		object-fit: cover;
		display: block;
	}
</style>